import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

import * as API from 'es6/core/api';
import {noticeError} from 'es6/core/errors';
import Localization from 'es6/services/localization';
import { partOfSpeech } from 'es6/helpers/localization';
import * as Paths from 'es6/core/paths';
import * as Result from 'es6/models/quiz-result';
import UserSettings from 'es6/models/user-settings';
import AppLauncher from 'es6/controllers/apps/app-launcher.js';
import Quizzes from 'es6/controllers/apps/quizzes';
import * as ImageManager from 'es6/services/image-manager';

const Helpers = { Localization: { partOfSpeech }};

// Globalize so it is accessible to legacy code.
// Make new APIs available to legacy front end components.
Object.assign(window.App, { Helpers, Paths });
Object.assign(window, { ImageManager, Localization, React, ReactDOM });
Object.assign(Smartfm.Apps.iKnow, { Quizzes });
Smartfm.Apps.QuizResult = Result;

window.addEventListener('load', function() {
  Promise.all([API.getSettings(), API.getSiteConfiguration()]).then(requests => {
    const userSettings = new UserSettings(requests[0]);
    const siteConfiguration = requests[1];

    // Load the app launcher.
    new AppLauncher(userSettings, siteConfiguration);
  }).catch(noticeError);
});
